
import React from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { useState } from 'react';
import Navbar from '../Components/Navbar';
import SubHeader from '../Components/SubHeader';
import { Footer } from '../Components/Footer';
import { useTranslation } from '../../TranslationContext';

// Interface pour les props de FAQItem
interface FAQItemProps {
  question: string;
  answer: string;
}

// Interface pour la structure d'un item FAQ
interface FAQItem {
  question: string;
  answer: string;
}

const FAQItem: React.FC<FAQItemProps> = ({ question, answer }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  
  return (
    <div className={`mb-4 rounded-lg overflow-hidden shadow-sm transition-all duration-300 ${isOpen ? 'bg-white' : 'bg-white hover:shadow-md'}`}>
      <button
        className="w-full py-5 px-6 flex justify-between items-center text-left"
        onClick={() => setIsOpen(!isOpen)}
        aria-label={isOpen ? t('collapse_faq', { question }) : t('expand_faq', { question })}
      >
        <span className="text-lg font-medium text-gray-900">{question}</span>
        {isOpen ? (
          <ChevronUp className="h-5 w-5" style={{ color: "#c06a70" }} />
        ) : (
          <ChevronDown className="h-5 w-5" style={{ color: "#c06a70" }} />
        )}
      </button>
      
      <div 
        className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96' : 'max-h-0'}`}
      >
        <div className="px-6 pb-6 pt-2 border-t border-gray-100" style={{ color: "#333333" }}>
          <p>{answer}</p>
        </div>
      </div>
    </div>
  );
};

export const FAQ = () => {
  const { t } = useTranslation();
  
  const faqItems: FAQItem[] = [
    {
      question: t('faq_mfa_question'),
      answer: t('faq_mfa_answer'),
    },
    {
      question: t('faq_data_protection_question'),
      answer: t('faq_data_protection_answer'),
    },
    {
      question: t('faq_customization_question'),
      answer: t('faq_customization_answer'),
    },
    {
      question: t('faq_uptime_question'),
      answer: t('faq_uptime_answer'),
    },
    {
      question: t('faq_integration_question'),
      answer: t('faq_integration_answer'),
    },
    {
      question: t('faq_support_question'),
      answer: t('faq_support_answer'),
    },
    {
      question: t('faq_user_management_question'),
      answer: t('faq_user_management_answer'),
    },
    {
      question: t('faq_pricing_question'),
      answer: t('faq_pricing_answer'),
    },
  ];

  return (
    <div style={{ backgroundColor: "#f5f5dc" }}>
      <Navbar />
      <SubHeader isDarkMode={false} />
      
      <div className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="lg:text-center mb-12">
            <h2 className="text-base font-semibold tracking-wide uppercase" style={{ color: "#c06a70" }}>
              {t('faq')}
            </h2>
            <p className="mt-2 text-3xl leading-8 font-bold tracking-tight sm:text-4xl" style={{ color: "#333333" }}>
              {t('frequently_asked_questions')}
            </p>
            <p className="mt-4 max-w-2xl text-xl lg:mx-auto" style={{ color: "#879bae" }}>
              {t('faq_subtitle')}
            </p>
          </div>
          
          <div className="max-w-3xl mx-auto">
            {faqItems.map((item, index) => (
              <FAQItem key={index} question={item.question} answer={item.answer} />
            ))}
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default FAQ;
// import React from 'react';
// import { ChevronDown, ChevronUp } from 'lucide-react';
// import { useState } from 'react';
// import Navbar from '../Components/Navbar'
// import SubHeader from '../Components/SubHeader';
// import {Footer} from '../Components/Footer';

// // Interface pour les props de FAQItem
// interface FAQItemProps {
//   question: string;
//   answer: string;
// }

// // Interface pour la structure d'un item FAQ
// interface FAQItem {
//   question: string;
//   answer: string;
// }

// const FAQItem: React.FC<FAQItemProps> = ({ question, answer }) => {
//   const [isOpen, setIsOpen] = useState(false);

//   return (
//     <div className="border-b border-gray-200">
//       <button
//         className="w-full py-6 flex justify-between items-center text-left"
//         onClick={() => setIsOpen(!isOpen)}
//       >
//         <span className="text-lg font-medium text-gray-900">{question}</span>
//         {isOpen ? (
//           <ChevronUp className="h-5 w-5 text-indigo-600" />
//         ) : (
//           <ChevronDown className="h-5 w-5 text-indigo-600" />
//         )}
//       </button>
//       {isOpen && (
//         <div className="pb-6">
//           <p className="text-gray-600">{answer}</p>
//         </div>
//       )}
//     </div>
//   );
// };

// export const FAQ = () => {
//   const faqItems: FAQItem[] = [
//     {
//       question: "What is multi-factor authentication (MFA)?",
//       answer: "Multi-factor authentication is a security method that requires users to provide two or more different proofs of identity to access an account. Ottenti offers several MFA options, including SMS, authentication applications, and physical security keys."
//     },
//     {
//       question: "How does Ottenti protect my users' data?",
//       answer: "Ottenti uses end-to-end encryption, stores data in secure data centers, and follows industry best practices for security. We comply with GDPR, CCPA, and other important data protection regulations."
//     },
//     {
//       question: "Can I customize the authentication interface?",
//       answer: "Yes, Ottenti offers complete customization options. You can adapt the interface to your brand colors, modify authentication flows, and customize messages for your users."
//     },
//     {
//       question: "What are the service uptime rates?",
//       answer: "Ottenti guarantees 99.99% service uptime. We maintain a redundant infrastructure and monitor our systems 24/7 to ensure reliable authentication at all times."
//     },
//     {
//       question: "How do I integrate Ottenti with my existing application?",
//       answer: "Ottenti provides easy-to-integrate SDKs and APIs for major platforms and programming languages. Our detailed documentation and technical support team will guide you through the integration process."
//     },
//     {
//       question: "What technical support is available?",
//       answer: "We offer 24/7 technical support for enterprise customers, with guaranteed response times based on your service level. Our team of experts is available by email, chat, and phone."
//     },
//     {
//       question: "How do I manage users and their permissions?",
//       answer: "Ottenti offers a comprehensive administration dashboard to manage users, roles, and permissions. You can easily add/remove users, set security policies, and track activities."
//     },
//     {
//       question: "What are the pricing options?",
//       answer: "We offer several packages tailored to the needs of businesses of all sizes, from startups to large accounts. Contact our sales team for a personalized quote based on your specific needs."
//     }
//   ];

//   return (
//     <div>
//       <Navbar />
//       <SubHeader isDarkMode={false}/>
//       <div className="bg-white py-12">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="lg:text-center mb-12">
//             <h2 className="text-base text-indigo-600 font-semibold tracking-wide uppercase">
//               FAQ
//             </h2>
//             <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
//               Frequently Asked Questions
//             </p>
//             <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto">
//               Find answers to the most common questions about our authentication services
//             </p>
//           </div>

//           <div className="max-w-3xl mx-auto">
//             {faqItems.map((item, index) => (
//               <FAQItem 
//                 key={index}
//                 question={item.question}
//                 answer={item.answer}
//               />
//             ))}
//           </div>
//         </div>
//       </div>

//       <Footer />
//     </div>
//   );
// };

// export default FAQ;